export default __webpack_public_path__ + "static/debug-swc-f2338a2c91f417fb608fdb8dc2775fcc.png";